module.exports = {
  factory: function graphicsFactory() {
    return {};
  },
  reset: function(graphics) {
    delete graphics.renderer;
  }
}



//////////////////
// WEBPACK FOOTER
// ./src/components/graphics.js
// module id = 188
// module chunks = 0